import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import updateUser from "../../services/updateUserDataApi";
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { getUserDetails } from "./userSlice";

export const saveUserProfile = createAsyncThunk("profile/updateProfile", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.saveProfile(data);
        if (response.status === 0) {           
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(getUserDetails());
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const saveProfileImage = createAsyncThunk("profile/saveProfileImage", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.saveProfileImage(data);
        if (response.status === 0) {    
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(getUserDetails());         
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const changePassword = createAsyncThunk("profile/updatePassword", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.changeUserPasssword(data);
        if (response.status === 0) {           
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const changeEmail = createAsyncThunk("profile/changeEmail", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.changeEmailAddress(data);
        if (response.status === 0) {           
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const verifyEmail = createAsyncThunk("profile/verifyEmail", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.verifyAndUpdateEmailAddress(data);
        if (response.status === 0) {           
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(getUserDetails());
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const changePhoneNumber = createAsyncThunk("profile/changePhoneNumber", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.changePhoneNumber(data);
        if (response.status === 0) {           
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const verifyPhoneNumber = createAsyncThunk("profile/verifyPhoneNumber", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUser.verifAndUpdateContactNumber(data);
        if (response.status === 0) {           
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(getUserDetails());
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

const updateUserSlice= createSlice({
    name: "updateUser",
    initialState: { 
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, saveUserProfile, "updateUser", "error", "updatingUser");
        handleAsyncThunk(builder, saveProfileImage, "updateProfileImage", "error", "updatingImage");
        handleAsyncThunk(builder, changePassword, "changePassword", "error", "changingPassword");
        handleAsyncThunk(builder, changeEmail, "changeEmail", "error", "changing" );
        handleAsyncThunk(builder, verifyEmail, "verifyEmail", "error", "verifying");
        handleAsyncThunk(builder, changePhoneNumber, "changePhoneNumber", "error", "changing");
        handleAsyncThunk(builder, verifyPhoneNumber, "verifyPhoneNumber", "error", "verifying");
    },
});

export default updateUserSlice.reducer;